import { css } from 'styled-components';
import { CFTokens } from '../../tokens';
//
// Tokens
//
export const CFBaseSwipeBarTokens = {
    COLOR: CFTokens.COLOR.MONO_4,
    HEIGHT: 4,
    WIDTH: 44,
};
//
// Helpers
//
export const CFBaseSwipeBarHelpers = {};
//
// Element Styles
//
export const CFBaseSwipeBarStyles = {
    Root: css `
    margin: 0 auto;
    width: ${CFBaseSwipeBarTokens.WIDTH}px;
    height: ${CFBaseSwipeBarTokens.HEIGHT}px;
    z-index: 1;
    border-radius: ${CFTokens.BORDER_RADIUS.PILL}px;
    background-color: ${CFBaseSwipeBarTokens.COLOR};
  `,
};
